import React from 'react';
import { Box, Container, Card, CardContent, Typography, Button } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useAuth } from '../contexts/AuthContext';

export default function NoOutletPage() {
  const { logout, user } = useAuth();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Card elevation={4} sx={{ borderRadius: 4 }}>
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: '50%',
                bgcolor: 'primary.main',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 2,
              }}
            >
              <LockIcon sx={{ fontSize: 36, color: '#fff' }} />
            </Box>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
              No Outlet Access
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              {user?.name ? `Hi ${user.name}, ` : ''}
              your account isn't linked to any restaurant outlet. Please contact your restaurant
              owner or Roll2Bowl support to enable access.
            </Typography>
            <Button variant="contained" onClick={logout}>
              Logout
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}
